/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { createContext, useContext, useReducer } from 'react';
import utilityAccountReducer from './UtilityAccountReducer';
import { IUtilityInfo } from '../../components/UtilityServiceSettings/IUtilityServiceSettingsProps';
import { IAny } from '../../components/DashboardKPIWidgets/IEnergyManagementProps';

export interface IUtilityAccountState {
  showModal: boolean;
  showDeactivateAccModal: boolean;
  showDeactivateIDSModal: boolean;
  showReactivateAccModal: boolean;
  showReactivateIDSModal: boolean;
  showReverifyModal: boolean;
  selectedUtility: IUtilityInfo;
  showMeterNameChangeModal: boolean;
  showConversionModal: boolean;
  editDetailsModal: boolean;
  showEnableIDSModal: boolean;
}

const initialState: IUtilityAccountState = {
  showModal: false,
  showDeactivateAccModal: false,
  showDeactivateIDSModal: false,
  showReactivateAccModal: false,
  showReactivateIDSModal: false,
  showReverifyModal: false,
  selectedUtility: {} as IUtilityInfo,
  showMeterNameChangeModal: false,
  showConversionModal: false,
  editDetailsModal: false,
  showEnableIDSModal: false
};

export const UtilityAccountContext = createContext<IAny>(initialState);

export const UtilityAccountProvider: React.FC<{}> = ({ children }) => {
  const [state, dispatch] = useReducer(utilityAccountReducer, initialState);

  const value: IAny = [state, dispatch];

  return (
    <UtilityAccountContext.Provider value={value}>
      {children}
    </UtilityAccountContext.Provider>
  );
};

export const useUtilityAccountContext = () => useContext(UtilityAccountContext);
